export const enum LoadingStatus {
  Loading = 'loading',
  Loaded = 'loaded',
  Error = 'error',
}
